import { render, staticRenderFns } from "./randomDraw.vue?vue&type=template&id=1d45effa&scoped=true&"
import script from "./randomDraw.vue?vue&type=script&lang=js&"
export * from "./randomDraw.vue?vue&type=script&lang=js&"
import style0 from "./randomDraw.vue?vue&type=style&index=0&id=1d45effa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d45effa",
  null
  
)

export default component.exports